import React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils'

type IconButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof Button>,
  'aria-label' | 'size' | 'variant'
> & {
  ariaLabel: string
  /** WAI-ARIA: space-separated accelerator hints for assistive technology */
  ariaKeyshortcuts?: string
  isActive?: boolean
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      children,
      onClick,
      ariaLabel,
      ariaKeyshortcuts,
      title,
      disabled,
      isActive = false,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="icon-sm"
        type="button"
        aria-label={ariaLabel}
        aria-keyshortcuts={ariaKeyshortcuts}
        title={title}
        onClick={onClick}
        disabled={disabled}
        aria-pressed={isActive || undefined}
        className={cn(isActive && 'bg-accent text-accent-foreground', className)}
        {...props}
      >
        {children}
      </Button>
    )
  }
)

IconButton.displayName = 'IconButton'
